import Superagent from 'superagent'
import LocalStorage from '../localstore'

const HOST_API = _CONST_.HOST_API

const errorMessage = {
    success: false,
    error: {
        message: 'Error de conexión'
    }
}

export default {
    request
}

function request(method, path, options = {}) {
    return new Promise((resolve, reject) => {
        try {

            const session = LocalStorage.getItem('session')

            Superagent(method, `${HOST_API}${path}`)
                .set('token', session? session.token : null)
                .timeout({deadline: 30000, response: 30000})
                .send(options.data)
                .query(options.query)
                .responseType(options.responseType || null)
                .end((err, res) => {

                    if(err) {

                        if(err.response && err.response.body)
                            return resolve(err.response.body)

                        return resolve(errorMessage)
                    }

                    resolve(res.body)
                })

        } catch(error) {
            console.log(error)
            resolve(errorMessage)
        }
    })
}